import { createSlice } from '@reduxjs/toolkit';
import { RootState } from 'initializers/types';

import { createReducers, createSelectors } from 'features/hiringV2/helpers';

import { INITIAL_DASHBOARD_STATE } from './constants';
import { HiringDashboardState } from './types';

const SLICE_NAME = 'dashboard';

const initialState = INITIAL_DASHBOARD_STATE;

const dashboardSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: createReducers(initialState),
});

const getDashboardState = (state: RootState) =>
  state.get('hiringV2').dashboard as HiringDashboardState;

// Selectors
export const dashboardSelectors = createSelectors(
  getDashboardState,
  initialState
);
export const dashboardActions = dashboardSlice.actions;

export const reducer = dashboardSlice.reducer;
